import { gql } from 'graphql-request';

import {
  CompanyEventTemplateCreatedAt,
  CompanyEventTemplateDisabledAt,
  CompanyEventTemplateEventTemplateID,
  CompanyEventTemplateEventTemplateName,
  CompanyEventTemplateHandlerArgsCompanySmartContractTemplateID,
  CompanyEventTemplateHandlerArgsGeneralLegerCompanyID,
  CompanyEventTemplateHandlerArgsGeneralLegerCompanyName,
  CompanyEventTemplateHandlerArgsGeneralLegerCompanyOwnerID,
  CompanyEventTemplateHandlerArgsGeneralLegerID,
  CompanyEventTemplateID,
  CompanyEventTemplateName,
  CompanyEventTemplateNanoID,
  CompanyEventTemplateSystemAt,
  CompanyEventTemplateUUID,
  CompanyEventTemplateUpdatedAt
} from '../companyEventTemplatesTypes';

export interface FetchCacheCompanyEventTemplateQueryResponse {
  companySmartContractTemplateId?: CompanyEventTemplateHandlerArgsCompanySmartContractTemplateID;
  createdAt: CompanyEventTemplateCreatedAt;
  disabledAt: CompanyEventTemplateDisabledAt;
  eventTemplate: {
    id: CompanyEventTemplateEventTemplateID;
    name: CompanyEventTemplateEventTemplateName;
  };
  handlerGeneralLedger: {
    company: {
      id: CompanyEventTemplateHandlerArgsGeneralLegerCompanyID;
      name: CompanyEventTemplateHandlerArgsGeneralLegerCompanyName;
      ownerId: CompanyEventTemplateHandlerArgsGeneralLegerCompanyOwnerID;
    };
    id: CompanyEventTemplateHandlerArgsGeneralLegerID;
  };
  handlerGeneralLedgerId: CompanyEventTemplateHandlerArgsGeneralLegerID;
  id: CompanyEventTemplateID;
  name: CompanyEventTemplateName;
  nanoId: CompanyEventTemplateNanoID;
  systemAt: CompanyEventTemplateSystemAt;
  updatedAt: CompanyEventTemplateUpdatedAt;
  uuid: CompanyEventTemplateUUID;
}

export const FETCH_CACHE_COMPANY_EVENT_TEMPLATES_QUERY = gql`
  query CacheCompanyEventTemplates(
    $filters: CompanyEventTemplatesFilters
    $sort: [CompanyEventTemplatesSortEnum]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    companyEventTemplates(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        companySmartContractTemplateId
        createdAt
        disabledAt
        eventTemplate {
          id
          name
        }
        handlerGeneralLedger {
          company {
            id
            name
            ownerId
          }
          id
        }
        handlerGeneralLedgerId
        id
        name
        nanoId
        systemAt
        updatedAt
        uuid
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
